import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiNoticeSectionDTO,
  NoticeSectionDTO,
} from "@lib/strapi/dtos/components/sections/noticeSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class NoticeSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiNoticeSectionDTO,
  ): Promise<NoticeSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new NoticeSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.style = strapiData.style;
    dto.content = await parseStrapiContent(strapiData.content);
    return dto;
  }
}
